/* This file is generated by @ankhorage/devtools. Do not edit manually. */
import type { StructureDescriptorDocument } from '@ankhorage/contracts/structure';

export const STRUCTURE_DESCRIPTOR_COMPILER_VERSION = '6.0.3';
export const STRUCTURE_DESCRIPTOR_FINGERPRINT = 'sha256:6c7d63faf1de59cb1ecdd60c60a3d3c2f501b855796943745858fde61a926198';

export const STRUCTURE_DESCRIPTOR = {
  "protocolVersion": 1,
  "packageName": "@ankhorage/contracts",
  "packageVersion": "22.3.0",
  "roots": {
    "auth-flow": "AuthFlowConfig",
    "screen-metadata": "ScreenMetadataSpec",
    "screen-requirements": "ScreenRequirements"
  },
  "descriptors": {
    "AuthFlowConfig": {
      "id": "AuthFlowConfig",
      "descriptor": {
        "kind": "object",
        "fields": {
          "forgotPasswordRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          },
          "otpRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          },
          "postSignInRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            }
          },
          "signInRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            }
          },
          "signOutRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          },
          "signUpRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          },
          "unauthorizedRoute": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          }
        }
      }
    },
    "ScreenMetadataSpec": {
      "id": "ScreenMetadataSpec",
      "descriptor": {
        "kind": "object",
        "fields": {
          "description": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          },
          "id": {
            "value": {
              "kind": "scalar",
              "type": "string"
            }
          },
          "name": {
            "value": {
              "kind": "scalar",
              "type": "string"
            }
          },
          "title": {
            "value": {
              "kind": "scalar",
              "type": "string"
            },
            "optional": true
          }
        }
      }
    },
    "ScreenRequirements": {
      "id": "ScreenRequirements",
      "descriptor": {
        "kind": "object",
        "fields": {
          "capabilities": {
            "value": {
              "kind": "set",
              "member": {
                "kind": "enum",
                "values": [
                  "barcodeScanner",
                  "cameraPreview",
                  "clipboard",
                  "ebookReader",
                  "filePicker",
                  "location",
                  "mediaPicker",
                  "notifications"
                ]
              }
            },
            "optional": true
          },
          "permissions": {
            "value": {
              "kind": "set",
              "member": {
                "kind": "enum",
                "values": [
                  "camera",
                  "clipboard",
                  "locationBackground",
                  "locationForeground",
                  "mediaLibrary",
                  "mediaLibraryWrite",
                  "microphone",
                  "notifications"
                ]
              }
            },
            "optional": true
          }
        }
      }
    }
  }
} as const satisfies StructureDescriptorDocument;
